/** @param {unknown} decodedToken */
export function jwtRoles(decodedToken) {
  const roles = decodedToken?.roles;
  if (!Array.isArray(roles)) {
    return [];
  }
  return roles.map((r) => String(r ?? "").trim()).filter(Boolean);
}

/** @param {unknown} decodedToken */
export function hasAcctAdminRole(decodedToken) {
  return jwtRoles(decodedToken).some((r) => r.toUpperCase() === "ACCT_ADMIN");
}
